import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from 'src/hooks/use-auth';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';
import { Issuer } from 'src/utils/auth';

const loginPaths = {
  [Issuer.Amplify]: paths.auth.amplify.login,
  [Issuer.Auth0]: paths.auth.auth0.login,
  [Issuer.Firebase]: paths.auth.firebase.login,
  [Issuer.JWT]: paths.auth.jwt.login
};

/** Path + query for return after login (keeps e.g. ?encResp= from payment gateways). */
function getReturnToPathAndQuery() {
  const path = window.location.pathname;
  const search = window.location.search;
  if (!path.startsWith('/') || path.startsWith('//')) {
    return '';
  }
  return `${path}${search}`;
}

export const AuthGuard = (props) => {
  const { children } = props;
  const router = useRouter();
  const { isAuthenticated, isInitialized, issuer } = useAuth();

  useEffect(() => {
    if (!isInitialized) {
      return;
    }
    if (!isAuthenticated) {
      const returnTo = getReturnToPathAndQuery();
      const qs = new URLSearchParams();
      if (returnTo) {
        qs.set('returnTo', returnTo);
      }
      const href = `${loginPaths[issuer]}?${qs.toString()}`;
      router.replace(href);
    }
  }, [isAuthenticated, isInitialized, issuer, router]);

  if (!isInitialized) {
    return null;
  }

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};
